<section id="notificationsDropdown" class="new-notification">
  <!-- Empty placeholder -->
  <div
    class="empty-placeholder"
    *ngIf="notifications && notifications.length <= 0"
  >
    <strong>اعلانی برای شما پیدا نشد</strong>
  </div>

  <!-- Notifications -->
  <div
    class="notification-list"
    fxLayout="column"
    *ngIf="notifications && notifications.length > 0"
  >
    <div
      fxLayout="row"
      class="notification"
      (click)="runFunctionality(notification)"
      matTooltipPosition="after"
      fxLayoutAlign="space-between center"
      [matTooltip]="convertDateToJa(notification.createdAt)"
      *ngFor="let notification of notifications; index as i"
    >
      <div class="message" fxFlex="86">
        {{ notification.notificationObject.description }}
      </div>
      <div class="icon" fxFlex="10">
        <jam-icon
          [color]="notification.seen ? '' : 'warn'"
          name="bell"
        />
      </div>
    </div>
  </div>
</section>
